/**
 *  Creates an id for a sub column.
 * @param columnName - Column name
 * @param id - id
 */
export function defaultSubColumnId(columnName: string, id: string) {
  return `${columnName}.${id}`;
}
